import { useContext } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import { DataContext } from '../context/DataProvider';
import ExecutiveDevices from './components/ExecutiveDevices/ExecutiveDevices.js';

const CreateBook = () => {
  const { toggleDToM } = useContext(DataContext);

  return (
    <>
      <Breadcrumb
        pageName={
          toggleDToM ? 'عناوین دستگاه های اجرایی ' : 'عناوین مراجع تصویب'
        }
      />
      <ExecutiveDevices />
    </>
  );
};

export default CreateBook;
